import React from 'react';
import { Translate } from 'react-jhipster';
import { Button, Modal, ModalBody, Row, Col, ModalHeader, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../approve-management.scss';

export interface ISuccessModalProps {
  showSuccessModal: boolean;
  message: string;
  handleClose: Function;
}

class SuccessModal extends React.Component<ISuccessModalProps> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal id="modalUserExists" isOpen={this.props.showSuccessModal} backdrop="static" centered toggle={this.props.handleClose}>
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center">
              <Col xs="auto">
                {' '}
                <img src={require('app/images/ic_tick.png')} style={{ width: '54px', marginTop: '30px' }} alt="" />{' '}
              </Col>
            </Row>
            <Row className="justify-content-center" style={{ marginTop: '10px' }}>
              <Col className="text-center">
                <p>{this.props.message}</p>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default SuccessModal;
